<template>
  <div class="head-container clearfix">
    <div class="header-left">
      <div class="header-title hidden-sm-and-down">Management Console</div>
      <showAside :toggle-click="toggleClick" />
      <breadcrumb />
    </div>

    <div class="header-right">
      <div class="header-user-con">
        <!-- i18n -->
        <div style="margin-right: 10px">
          <el-dropdown trigger="click" @command="changeLanguage">
            <span class="el-dropdown-link">
              {{ locale.toUpperCase() }}<i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="cn">中文</el-dropdown-item>
              <el-dropdown-item command="en">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <!-- 信封 -->
        <div class="btn-message hidden-sm-and-down">
          <el-badge :value="messageValue">
            <router-link to="/notify/email-list?type=dail">
              <i class="el-icon-message" />
            </router-link>
          </el-badge>
        </div>
        <!-- 全屏显示 -->
        <div class="btn-fullscreen hidden-sm-and-down" @click="handleFullScreen">
          <el-tooltip
            effect="dark"
            :content="fullscreen ? 'cancelFullScreen' : 'fullScreen'"
            placement="bottom"
          >
            <i class="el-icon-full-screen" />
          </el-tooltip>
        </div>
        <!-- 消息中心 -->
        <div class="btn-bell hidden-sm-and-down">
          <el-badge :value="value">
            <router-link to="/notify/monitor_alerts">
              <i class="el-icon-bell" />
            </router-link>
          </el-badge>
        </div>
        <el-divider direction="vertical" />
        <!-- 用户名下拉菜单 -->
        <el-dropdown class="avatar-container" trigger="hover" @command="handleCommand">
          <div class="avatar-wrapper">
            <img :src="imgUrl" class="user-avatar" />
            <div style="margin-left: 10px;font-size: 16px">{{ userInfo.username }}</div>
          </div>
          <el-dropdown-menu slot="dropdown" class="user-dropdown">
            <router-link class="inlineBlock" to="/">
              <el-dropdown-item>Back to</el-dropdown-item>
            </router-link>
            <el-dropdown-item command="a">Settings</el-dropdown-item>
            <el-dropdown-item divided>
              <span style="display:block;" @click="logout">Logout</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 更新密码 -->
    <el-dialog
      title="Account Setting"
      width="40%"
      :visible.sync="updatePasswordVisible"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <el-form
        label-position="left"
        class="grid-form"
        :model="accountSetting"
        :rules="rules"
        label-width="120px"
        ref="accountSettingForm"
      >
        <el-form-item label="Email" prop="email">
          <el-input v-model="accountSetting.email" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updatePasswordVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmUpdatePasswordClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import showAside from './showAside';
  import breadcrumb from './Breadcrumb';
  import cacheImgUrl from 'static/hypertap.png';
  import { mapGetters } from 'vuex';
  import { updateAccount } from 'api/account';
  import { validateEmail } from 'utils/validator';
  export default {
    components: {
      showAside,
      breadcrumb,
    },
    data() {
      return {
        fullscreen: false,
        value: '',
        imgUrl: '',
        messageValue: '',
        updatePasswordValue: '',
        accountSetting: {
          email: '',
        },
        rules: {
          email: [{ validator: validateEmail, required: true }],
        },
        updatePasswordVisible: false,
        fullWidth: document.documentElement.clientWidth,
      };
    },
    async mounted() {
      const imgUrl = sessionStorage.getItem('imgUrl');
      this.imgUrl = imgUrl !== 'undefined' ? imgUrl : cacheImgUrl;

      this.rightWidth();
    },
    computed: {
      ...mapGetters(['locale', 'userInfo']),
      isCollapse: {
        get: function() {
          return this.$store.state.app.isCollapse;
        },
        set: function(newValue) {
          this.$store.commit('app/SET_IS_COLLAPSE', newValue);
        },
      },
    },
    methods: {
      changeLanguage(val) {
        this.$store.dispatch('app/setLanguage', val);
        this.$i18n.locale = val;
      },
      rightWidth() {
        if (this.fullWidth <= 768) {
          this.isCollapse = true;
        }
      },
      handleCommand(command) {
        if (command == 'a') {
          this.updateAccountSetting();
        }
      },
      updateAccountSetting() {
        // this.updatePasswordValue = sessionStorage.getItem('passWord');
        this.updatePasswordVisible = true;
      },
      confirmUpdatePasswordClick() {
        this.$refs.accountSettingForm.validate((valid) => {
          if (valid) {
            updateAccount({ id: this.userInfo.accountId, email: this.accountSetting.email }).then(
              () => {
                this.$message({
                  message: 'Update Success',
                  type: 'success',
                });
                this.updatePasswordVisible = false;
              }
            );
          }
        });
      },
      toggleClick() {
        this.isCollapse = !this.isCollapse;
      },
      // 用户名下拉菜单选择事件
      logout() {
        this.$store.dispatch('user/logout').then(() => {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('userName');
          this.$router.push('/login');
        });
      },
      // 全屏事件
      handleFullScreen() {
        let element = document.documentElement;
        if (this.fullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } else {
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
          }
        }
        this.fullscreen = !this.fullscreen;
      },
    },
  };
</script>
<style lang="scss" scoped>
  $base-color: var(--header-bg-color);
  .head-container {
    display: flex;
    height: 60px;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1002;
    width: 100%;
    -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
    border-bottom: 1px solid #f0f0f0;
    background-color: $base-color;
  }
  .header-left {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 10px;
    flex: 8;
    .header-title {
      font-size: 26px;
      color: #fff;
    }
  }
  .header-right {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: right;
    flex: 3;
    padding-right: 10px;
  }
  .header-user-con {
    display: flex;
    height: 50px;
    gap: 15px;
    align-items: center;
  }
  .btn-fullscreen {
    font-size: 20px;
    cursor: pointer;
    color: #fff;
    position: relative;
    text-align: center;
    border-radius: 15px;
  }

  .btn-message {
    position: relative;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
    font-size: 20px;
    .el-icon-message {
      color: #fff;
    }
  }

  .btn-bell {
    position: relative;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
    font-size: 20px;
  }
  .btn-bell-badge {
    position: absolute;
    right: 0;
    top: 8px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
  }
  .btn-bell .el-icon-bell {
    color: #fff;
  }
  .user-name {
    margin-left: 10px;
  }
  .user-avator {
    margin-left: 20px;
  }
  .user-avator img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .el-dropdown-link {
    color: #fff;
    cursor: pointer;
  }
  .el-dropdown-menu__item {
    text-align: center;
  }
  .avatar-container {
    font-size: 20px;
    color: #fff;
    display: flex;
    .avatar-wrapper {
      cursor: pointer;
      position: relative;
      line-height: initial;
      align-items: center;
      display: flex;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
    }
  }
</style>
